






















































import Vue, { Component } from "vue";
import _ from "lodash";
import {
  createComponent,
  watch,
  ref,
  computed,
  onBeforeUnmount,
} from "@vue/composition-api";
import router from "@/router";
import DecisionForm from "@/apps/management/decision/DecisionForm.vue";
import { ResourceItem } from "@megarax/client/src/resources/ResourceItem";
import { RevisionItem } from "@megarax/client/src/resources/RevisionItem";
import { DetailActions } from "@megarax/client/src/actions";
import { ResourceAppModule } from "../../shared/app";

interface Props {
  module: ResourceAppModule;
  value: any;
  isEditable: boolean;
  editing: boolean;
}

export default createComponent<Props>({
  components: {
    DecisionForm,
  },
  name: "ResourceItemCard",
  props: {
    module: {
      required: true,
    },
    value: {
      required: true,
    },
    isEditable: {
      default: false,
    },
    editing: {
      default: false,
    },
  },
  setup(props, ctx) {
    const { formComponent, sheetComponent } = props.module;

    const showDuplicateButton = props.value instanceof RevisionItem;

    const editableValue = ref<ResourceItem>();

    const form = ref<any>(null);

    function resetEditableValue() {
      editableValue.value = _.cloneDeep(props.value);
    }

    watch(
      () => props.editing,
      (editing) => {
        if (editing) resetEditableValue();
      },
    );

    function startEdit() {
      ctx.emit("update:editing", true);
    }

    async function onDeleteClick() {
      ctx.emit("delete");
    }

    const observer = ref(null);

    async function saveEdit() {
      try {
        await form.value.validate();

        ctx.emit("input", editableValue.value);
      } catch {
        ctx.root.$notify.error("Popraw błędy w formularzu.");
      }
    }

    function preventNav(event: BeforeUnloadEvent) {
      if (!props.editing) return;
      (event || window.event).returnValue = "";
      return "";
    }
    window.addEventListener("beforeunload", preventNav);

    onBeforeUnmount(() => {
      window.removeEventListener("beforeunload", preventNav);
    });

    return {
      form,
      formComponent,
      sheetComponent,
      editableValue,
      saveEdit,
      onDeleteClick,
      startEdit,
      observer,
      showDuplicateButton,
    };
  },
});
